'use strict';

/**
 * Component for weight
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ItemView = require('base/Colido.ItemView');

var template = require('../../templates/components/field-weight.hbs');

var WeightComponent = ItemView.extend({
    template: template,

    className: function() {
        var field = this.getOption('field');

        return 'form-component component-' + _.camelToHyphen(field.type);
    },

    ui: function(){
        var field = this.getOption('field');

        return {
            'sizeInputWeight': '[name="' + field.name + '"]',
            'sizeInputWeightLbs': '[name="weightLbs"]',
            'sizeInputWeightOz': '[name="weightOz"]',
            'selectWeightUnit': 'select[name="' + field.unitField + '"]',
        };
    },

    events: {
        'change @ui.selectWeightUnit': 'weightInputChanged',
    },

    viewData: {
        field: function() {
            return this.getOption('field');
        },

        isGroupChild: function() {
            return this.getOption('isGroupChild');
        },
    },

    /**
     * Resets the states and data of the component
     */
    reset: function() {
        var field = this.getOption('field');

        // Render select weight unit
        this.renderSelectOptions(
            this.ui.selectWeightUnit,
            App.BaseModule.weightUnitsCollection,
            'key',
            'key',
            function(option) {
                return this.model && this.model.get(field.unitField) == option.value;
            }.bind(this)
        );

        this.weightInputChanged();
    },

    onShow: function() {
        this.reset();
    },

    weightInputChanged: function(){
        var unit = this.ui.selectWeightUnit.val();

        this.$('.weight-select-uni-default').hide();
        this.$('.weight-select-uni-lbs').hide();

        if (unit === 'lbs') {
            // if lbs is selected, show lbs and oz and set the values for them
            this.$('.weight-select-uni-lbs').show();
            var weightLbs = parseFloat(this.ui.sizeInputWeight.val().trim());
            var weightOz = (weightLbs - Math.floor(weightLbs)) * 16;
            weightLbs = Math.floor(weightLbs);
            this.ui.sizeInputWeightLbs.val(weightLbs);
            this.ui.sizeInputWeightOz.val(Math.round(weightOz * 10000) / 10000);
            this.ui.sizeInputWeightLbs.trigger('keydown');
            this.ui.sizeInputWeightOz.trigger('keydown');
        } else {
            // standard normal human unit. nothing special
            this.$('.weight-select-uni-default').show();
        }
    },

    getData: function() {
        var data = {};
        var field = this.getOption('field');

        var weight;
        var weightUnit = this.ui.selectWeightUnit.val().trim();

        if (weightUnit === 'lbs') {
            // if lbs is selected, convert the oz-value into lbs and add it to the lbs-value
            weight = parseFloat(this.ui.sizeInputWeightLbs.val().trim()) || 0;
            weight += (parseFloat(this.ui.sizeInputWeightOz.val().trim()) || 0) / 16;
        } else {
            weight = this.ui.sizeInputWeight.val().trim();
        }

        data[field.name] = weight;
        data[field.unitField] = weightUnit;

        return data;
    },
});

module.exports = WeightComponent;